import { Box, Typography } from "@mui/material";
import React from "react";

const ErrorComponent = ({ message = "Something went wrong" }) => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography variant="h6">{message}</Typography>
    </Box>
  );
};

export default ErrorComponent;
